import { useEnvironment } from '@hooks/use-environment';

interface DevBannerProps {
  className?: string;
}

export function DevBanner({ className }: DevBannerProps) {
  // Check if NODE_ENV is set to "dev"
  const { isStaging, isDev } = useEnvironment();

  
  if (!isDev && !isStaging) {
    return null;
  }

  return (
    <div className={`fixed top-0 left-0 z-50 bg-red-600 text-white rounded-br-md px-1 py-1 text-xs font-medium ${className || ''}`}>
        {isStaging ? 'STG' : 'DEV'}
    </div>
  );
}